import Button from '@atoms/Button/Button';
import vacancyDetailsType from '@lib/proptypes/vacancyDetails';
import VacancyDetails from '@molecules/VacancyDetails/VacancyDetails';
import ArrowUpIcon from '@svg/arrow-up.svg';
import scrollTo from '@utils/scrollTo';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import styles from './ApplyCta.module.scss';

export default function ApplyCta({
  vacancy,
  vacancyDetails,
  formInView,
  applicationFormRef,
}) {
  const [distanceFromTop, setDistanceFromTop] = useState(0);
  const [showStickyBar, setShowStickyBar] = useState(false);

  const { ref: staticCtaRef, inView: ctaInView } = useInView({
    onChange: (inView, entry) => {
      setDistanceFromTop(entry.target.getBoundingClientRect().top);
    },
    initialInView: true,
  });

  useEffect(() => {
    if (distanceFromTop > 0) {
      setShowStickyBar(false);
      return;
    }
    setShowStickyBar(!formInView && !ctaInView);
  }, [formInView, ctaInView, distanceFromTop]);

  const handleScroll = () =>
    scrollTo({ scrollToRef: { current: document.body } });

  return (
    <>
      <Button
        ref={staticCtaRef}
        onClick={() => scrollTo({ scrollToRef: applicationFormRef })}
        label="Solliciteren"
        extraClasses={styles.staticCta}
      />

      <div
        className={classNames(
          styles.fixedBar,
          'u-container-width',
          !showStickyBar && styles.fixedBarHidden
        )}
      >
        <div className={classNames(styles.fixedBarItem, styles.content)}>
          <div className="u-visually-hidden@until-md">
            <p className="u-typography-heading-4 u-mb-1">{vacancy}</p>

            <VacancyDetails details={vacancyDetails} isRow hideSalary />
          </div>

          <Button
            onClick={() => scrollTo({ scrollToRef: applicationFormRef })}
            label="Solliciteer nu"
            extraClasses={styles.fixedCta}
          />
        </div>

        <button
          type="button"
          className={classNames(styles.fixedBarItem, styles.scrollToTop)}
          aria-label="Scroll naar boven"
          title="Scroll naar boven"
          onClick={handleScroll}
        >
          <ArrowUpIcon className={styles.icon} />
        </button>
      </div>
    </>
  );
}

ApplyCta.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  applicationFormRef: PropTypes.any,
  vacancy: PropTypes.string,
  formInView: PropTypes.bool,
  vacancyDetails: vacancyDetailsType,
};
